export var MultifactorAuthenticationIA = function MultifactorAuthenticationIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return MULTIFACTOR_AUTHENTICATION_TITLE(strictLocalize);
    },
    getDescription: function getDescription() {
      return [MULTIFACTOR_AUTHENTICATION_DESCRIPTION(strictLocalize), MULTIFACTOR_AUTHENTICATION_CONTACT_US(strictLocalize)];
    }
  };
};
var MULTIFACTOR_AUTHENTICATION_TITLE = function MULTIFACTOR_AUTHENTICATION_TITLE(strictLocalize) {
  return strictLocalize({
    id: "A77NhJ",
    defaultMessage: [{
      "type": 0,
      "value": "Authentification multifacteur"
    }]
  });
};
var MULTIFACTOR_AUTHENTICATION_DESCRIPTION = function MULTIFACTOR_AUTHENTICATION_DESCRIPTION(strictLocalize) {
  return strictLocalize({
    id: "q2lRAt",
    defaultMessage: [{
      "type": 0,
      "value": "Chez Faire, nous avons mis en place des mesures de sécurité pour protéger votre compte contre tout accès non autorisé. Dans le cadre de ces mesures, nous pouvons être amenés à vous demander des informations supplémentaires, telles qu'un code d'authentification multifacteur (MFA), afin de nous assurer que vous seul avez accès à votre compte. Cette mesure vise à protéger la sécurité et la confidentialité de votre compte et à empêcher toute activité non autorisée."
    }]
  });
};
var MULTIFACTOR_AUTHENTICATION_CONTACT_US = function MULTIFACTOR_AUTHENTICATION_CONTACT_US(strictLocalize) {
  return strictLocalize({
    id: "L5tq/m",
    defaultMessage: [{
      "type": 0,
      "value": "N'hésitez pas à nous contacter si vous avez des questions concernant l'authentification multifacteur."
    }]
  });
};